ACC.headerAccount = {
    loadSupportContact: function () {
        $('.js-support').each(function(){
            var $this = $(this);
            var url = ($this.data('contentUrl'));
            $this.load(url, function(){
                KMVP.regionalassortment.bindZipCodeChangePost($(this));
                ACC.headerAccount.initResetPostalCodeButtonHandler();
            });
        });
    },

    initResetPostalCodeButtonHandler: function () {
        $(".js-contact-reset-postalcode").on("click", function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            $.ajax({
                url: url,
                success: function (data) {
                    window.location.reload();
                }
            })
        });
    }
};

$(document).ready(function () {
    with (ACC.headerAccount) {
        loadSupportContact();
    }
});
